import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IPaymentConfig, PermissionsService, ITaxSubsection, IPaymentOption, IPaymentProcessor } from '../../commons';
// State
import { Store } from '@ngrx/store';

import * as fromPaymentConfig from './state/payment-config.selectors';
import * as fromHome from '../home/state/home.selectors';
import * as PaymentConfigAction from './state/payment-config.actions';
import * as lgeApp from '../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';

@Component({
  selector: 'payment-config-screen',
  templateUrl: 'payment-config.component.html',
  styleUrls: ['payment-config.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentConfigScreenComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() private pending$: Observable<boolean>;
  private pendingSubscription: Subscription;
  private pending: boolean;
  @Input() private error$: Observable<string | null>;
  private errorSubscription: Subscription;
  private error: string | null;
  @Input() private stateData$: Observable<IPaymentConfig[] | null>;
  private stateDataSubscription: Subscription;
  @Input() private subsectionsData$: Observable<ITaxSubsection[] | null>;
  private subsectionDataSubscription: Subscription;
  @Input() private paymentOptionData$: Observable<IPaymentOption[] | null>;
  private paymentOptionDataSubscription: Subscription;
  @Input() private paymentProcessorData$: Observable<IPaymentProcessor[] | null>;
  paymentProcessorDataSubscription: Subscription;
  paymentConfigDetails: IPaymentConfig[] = [];
  paymentProcessorDetails: IPaymentProcessor[] = [];
  paymentOptionsDetails: IPaymentOption[] = [];
  taxExemptDetails: ITaxSubsection[] = [];

  constructor(
    private store: Store<fromPaymentConfig.State>,
    private storeHome: Store<fromHome.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private errorParse: ErrorParseService,
    private permissionService: PermissionsService
  ) {
  }


  ngOnInit() {
    this.selectState();
    this.startSubscriptions();
    this.createForms();
  }

  // Select state
  private selectState(): void {
    this.pending$ = this.store.select(fromPaymentConfig.getPaymentConfigScreenPending);
    this.stateData$ = this.store.select(fromPaymentConfig.getPaymentConfigState);
    this.subsectionsData$ = this.store.select(fromPaymentConfig.getSubsectionsState);
    this.paymentOptionData$ = this.store.select(fromPaymentConfig.getPaymentOptionState);
    this.paymentProcessorData$ = this.store.select(fromPaymentConfig.getPaymentProcessorState);
    this.error$ = this.store.select(fromPaymentConfig.getPaymentConfigScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
  }

  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading...');
        this.ref.markForCheck();
      })
    } else {
      this.ams.closeDialog().then(() => {
        if (this.error !== null && this.error !== undefined && this.error !== '') {
          this.displayError(this.error);
        }
      });
      this.ref.markForCheck();
    }
  }

  private displayError(error: any): void {
    let errorTitle = "Loading Error";
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
      errorMessage = this.errorParse.translateCCError(error);
    } else if (this.errorParse.foundKeyWord(error, "DUPLICATION")) {
      errorTitle = "WARNING!!! CONFIGURATION EXISTED FOR SELECTED TIME RANGE"
      errorMessage = `CallStack: ${error.message}`
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert(errorTitle, errorMessage);
    this.ams.alert.afterClosed().subscribe(result => {
      this.store.dispatch(new PaymentConfigAction.PaymentConfigScreenErrorReset());
    });
    this.ref.markForCheck();
  }

  // Create reactive forms
  private createForms(): void {

  }
  // Opens sidenav if on mobile
  public openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }
  hasRole(role) {
    return this.permissionService.hasRoles(role);
  }
  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$
      .subscribe(data => {
        this.pending = data;
        this.displayLoader(this.pending);
        this.ref.markForCheck();
      });
    this.errorSubscription = this.error$
      .subscribe(data => {
        this.error = data;
        this.ref.markForCheck();
      });
    this.stateDataSubscription = this.stateData$
      .subscribe(data => {
        if (data !== null) {
          this.paymentConfigDetails = data;
        }
        this.ref.markForCheck();
      });
    this.subsectionDataSubscription = this.subsectionsData$
      .subscribe(data => {
        if (data != null) {
          this.taxExemptDetails = data;
        }
        this.ref.markForCheck();
      })
    this.paymentOptionDataSubscription = this.paymentOptionData$
      .subscribe(data => {
        if (data != null) {
          this.paymentOptionsDetails = data;
        }
        this.ref.markForCheck();
      })
    this.paymentProcessorDataSubscription = this.paymentProcessorData$
      .subscribe(data => {
        if (data != null) {
          this.paymentProcessorDetails = data;
        }
        this.ref.markForCheck();
      })
  }
  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.store.dispatch(new PaymentConfigAction.LoadPaymentConfigStateInit());
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.stateDataSubscription.unsubscribe();
    this.subsectionDataSubscription.unsubscribe();
    this.paymentOptionDataSubscription.unsubscribe();
    this.paymentProcessorDataSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.endSubscriptions();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.store.dispatch(new PaymentConfigAction.LoadSubsectionsState());
      this.store.dispatch(new PaymentConfigAction.LoadPaymentOptionState());
      // this.store.dispatch(new PaymentConfigAction.LoadPaymentProcessorState());
      // this.store.dispatch(new PaymentConfigAction.LoadPaymentConfigState());
    });
  }
}